import React from 'react';
import styles from './thermography.module.css';
import { formatDelta, formatTemp } from '../../modules/thermography/thermography';

/** Valores da avaliação anterior no mesmo local, em uma linha curta. */
function previousLabel(row) {
  const previous = row.previous;
  if (!previous) return '—';
  if (previous.right != null || previous.left != null) {
    const sides = `D ${formatTemp(previous.right)} · E ${formatTemp(previous.left)}`;
    return previous.delta != null ? `${sides} (${formatDelta(previous.delta)})` : sides;
  }
  return formatTemp(previous.value);
}

/**
 * Tabela da avaliação termográfica agrupada por região: direito, esquerdo,
 * delta T (direito menos esquerdo, destacado acima do limiar) e, com
 * `showPrevious`, os valores da avaliação anterior. Locais sem lado ocupam
 * as duas colunas. `classes`: troca a classe da tabela (o PDF usa a do papel).
 */
const ThermographyTable = ({ groups, showPrevious = false, classes }) => {
  const tableClass = classes ? classes.table : styles.table;
  const columns = showPrevious ? 5 : 4;

  return (
    <div className={classes ? undefined : styles.tableScroll}>
      <table className={tableClass}>
        <thead>
          <tr>
            <th>Local</th>
            <th>Direito (°C)</th>
            <th>Esquerdo (°C)</th>
            <th>ΔT (D − E)</th>
            {showPrevious && <th>Anterior</th>}
          </tr>
        </thead>
        <tbody>
          {groups.map((group) => (
            <React.Fragment key={group.region.key}>
              <tr className={styles.regionRow}>
                <td colSpan={columns}>{group.region.label}</td>
              </tr>
              {group.rows.map((row) => (
                <tr key={row.id}>
                  <td><span className={styles.siteName}>{row.label}</span></td>
                  {row.bilateral ? (
                    <>
                      <td className={styles.num}>{formatTemp(row.right)}</td>
                      <td className={styles.num}>{formatTemp(row.left)}</td>
                    </>
                  ) : (
                    <td className={`${styles.num} ${styles.center}`} colSpan={2}>{formatTemp(row.value)}</td>
                  )}
                  <td>
                    {row.delta != null
                      ? <span className={`${styles.delta} ${row.asymmetric ? styles.deltaAlert : ''}`}>{formatDelta(row.delta)}</span>
                      : '—'}
                  </td>
                  {showPrevious && <td className={styles.previous}>{previousLabel(row)}</td>}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ThermographyTable;
